export const CalendarExpiredOrWithdrawnIcon = () => (
  <svg
    width="171"
    height="171"
    viewBox="0 0 171 171"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="85.5" cy="85.5" r="85.5" fill="#EBF4F5" />
    <g opacity="0.8">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.8143 44.7554C54.6325 44.7554 52.0532 47.3347 52.0532 50.5164V56.2775H46.2921C39.9287 56.2775 34.77 61.4361 34.77 67.7996V125.41C34.77 131.774 39.9287 136.932 46.2921 136.932H115.425C121.788 136.932 126.947 131.774 126.947 125.41V67.7996C126.947 61.4361 121.788 56.2775 115.425 56.2775H109.664V50.5164C109.664 47.3347 107.085 44.7554 103.903 44.7554C100.721 44.7554 98.1417 47.3347 98.1417 50.5164V56.2775H63.5753V50.5164C63.5753 47.3347 60.996 44.7554 57.8143 44.7554ZM57.8143 77.2102C54.6325 77.2102 52.0532 79.7895 52.0532 82.9712C52.0532 86.153 54.6325 88.7323 57.8143 88.7323H103.903C107.085 88.7323 109.664 86.153 109.664 82.9712C109.664 79.7895 107.085 77.2102 103.903 77.2102H57.8143Z"
        fill="#A4E0E0"
      />
    </g>
    <path
      d="M66.4573 51.226V32.0225M104.864 51.226V32.0225M62.9102 76.0907H107.859M48.4587 122.051H122.863C128.166 122.051 132.465 117.752 132.465 112.449V51.226C132.465 45.9231 128.166 41.6242 122.863 41.6242H48.4587C43.1558 41.6242 38.8569 45.9231 38.8569 51.226V112.449C38.8569 117.752 43.1558 122.051 48.4587 122.051Z"
      stroke="#0B8397"
      strokeWidth="8.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M149.772 113.803C149.772 127.807 138.42 139.159 124.417 139.159C110.414 139.159 99.062 127.807 99.062 113.803C99.062 99.8001 110.414 88.4482 124.417 88.4482C138.42 88.4482 149.772 99.8001 149.772 113.803Z"
      fill="#EBF4F5"
    />
    <path
      d="M124.417 99.9184V115.212H134.278M149.772 113.803C149.772 127.807 138.42 139.159 124.417 139.159C110.414 139.159 99.062 127.807 99.062 113.803C99.062 99.8001 110.414 88.4482 124.417 88.4482C138.42 88.4482 149.772 99.8001 149.772 113.803Z"
      stroke="#EBF4F5"
      strokeWidth="7.24434"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M133.851 133.616C146.096 133.616 156.022 123.689 156.022 111.445C156.022 99.2 146.096 89.2737 133.851 89.2737C121.606 89.2737 111.68 99.2 111.68 111.445C111.68 123.689 121.606 133.616 133.851 133.616ZM131.541 97.5869C131.541 96.3114 132.575 95.2774 133.85 95.2774C135.126 95.2774 136.16 96.3114 136.16 97.5869V109.134L143.088 109.134C144.364 109.134 145.398 110.168 145.398 111.443C145.398 112.719 144.364 113.753 143.088 113.753L133.85 113.753C133.238 113.753 132.65 113.51 132.217 113.077C131.784 112.644 131.541 112.056 131.541 111.444V97.5869Z"
      fill="#A4E0E0"
    />
    <path
      d="M129.724 99.6517V114.59H139.355M154.49 113.214C154.49 126.891 143.402 137.979 129.724 137.979C116.046 137.979 104.958 126.891 104.958 113.214C104.958 99.5361 116.046 88.4482 129.724 88.4482C143.402 88.4482 154.49 99.5361 154.49 113.214Z"
      stroke="#0B8397"
      strokeWidth="8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
